export const UNION_SALE_PROGRAM_CODE = "UNIONSALE";

// Upstream cap, inclusive. Only /trend accepts wider ranges.
export const UNION_SALE_MAX_RANGE_DAYS = 31;

export const EM_DASH = "—";
export const PRODUCT_GROUP_BY = "family";
export const PRODUCT_TOP_N = 10;

export const PRODUCT_COLORS = [
  "#4B51B3",
  "#F5A524",
  "#00B8D9",
  "#E5484D",
  "#30A46C",
  "#8E4EC6",
  "#F5D90A",
  "#0B7285",
  "#D6409F",
  "#5B6A7D",
];

export const PRODUCT_OTHERS_COLOR = "#C3C9D4";

export const UNION_SALE_UPSTREAM_MESSAGE =
  "Sale data is temporarily unavailable. Please try again shortly.";

export const UNION_SALE_UPSTREAM_PREFIX = "Union sale API";
